export default __webpack_public_path__ + "static/media/cat-5.cc7d1146.svg";